import { useEffect } from 'react';

const AdsTxt = () => {
  const adsTxtContent = `# Version 0.4.25

#FASTchannels
inventorypartnerdomain=fastchannels.tv
fastchannels.tv, 45154, DIRECT
google.com, pub-6275814287904645, DIRECT, f08c47fec0942fa0

#ElectricNOW INHOUSE
google.com, pub-4875891513811210, DIRECT, f08c47fec0942fa0

#PUBMATIC
pubmatic.com, 163000, DIRECT, 5d62403b186f2ace

#BEACHFRONT
Beachfront.com, 15084, DIRECT, e2541279e8e2ca4d

#Spacemob
inventorypartnerdomain=space-mob.com

#COLOSSUS
supply.colossusssp.com, 528, DIRECT, 6c5b49d96ec1b458
appnexus.com, 10490, RESELLER, f5ab79cb980f11d1
yieldmo.com, 3081538394287710485, RESELLER, #ortbctv

#RadiantMedia Authorized Inventory Partner
inventorypartnerdomain=radiantmedia.io

#SPANGLISH
inventorypartnerdomain=spanglishmovies.com

#Adtelligent
adtelligent.com, 742663, DIRECT, 8ce87912eb022a51
pubmatic.com, 161562, RESELLER, 5d62403b186f2ace
Media.net, 8CU27M373, RESELLER
contextweb.com, 563480, RESELLER, 89ff185a4c4e857c
video.unrulymedia.com, 3139274702404301777, RESELLER, 6f752381ad5ec0e5

#Daily Motion
telaria.com, a21zu-22lto, RESELLER, 1a4e959a1b50034a
tremorhub.com, a21zu-22lto, RESELLER, 1a4e959a1b50034a
nsightvideo.com,73566,RESELLER

#WURL
inventorypartnerdomain=wurl.com
applovin.com, 67139, DIRECT
applovin.com, 2713cc543ecb0969b83e3fdbf9ff011f, DIRECT

#MOBFOX
uis.mobfox.com, 1967, DIRECT, 5529a3d1f59865be
improvedigital.com, 2417, RESELLER
lemmatechnologies.com, 942, RESELLER, 7829010c5bebd1fb

#LDS
inventorypartnerdomain=littledotstudios.com

#AWG
google.com, pub-9130183266015225, DIRECT, f08c47fec0942fa0

#theMediaSense
INVENTORYPARTNERDOMAIN=themediasense.com
INVENTORYPARTNERDOMAIN=adte.com

#C360
C360.com, 2155, DIRECT
inventorypartnerdomain=C360.com
freewheel.tv, 531689-d-523319, RESELLER
freewheel.tv, sg1217511, RESELLER
freewheel.tv, sg1217511-523319, RESELLER

#montetizego
omgstudios.com, 201020241, DIRECT, f08c47fec0942fa0
inventorypartnerdomain=omgstudios.com
bigedition.com, 20251020, DIRECT, 3c91030819ca42
inventorypartnerdomain=bigedition.com

#Rhebus
inventorypartnerdomain=fancyamovie.com

#adman illumin
inventorypartnerdomain=admanmedia.com
admanmedia.com, 2030, DIRECT

#GOGOCTV
gogoctv.com, 90731296, DIRECT, 8e9cecc3d1ed840f
gogoctv.com, 90931174, DIRECT, 8e9cecc3d1ed840f
gogoctv.com, 15102626, DIRECT, 8e9cecc3d1ed840f
gogoctv.com, 76374124, DIRECT, 8e9cecc3d1ed840f
gogoctv.com, 61916071, DIRECT, 8e9cecc3d1ed840f
gogoctv.com, 41161058, DIRECT, 8e9cecc3d1ed840f

#sabio
sabio.us, 100136, DIRECT, 96ed93aaa9795702
freewheel.tv, 1606620, RESELLER
freewheel.tv, 1606633, RESELLER
freewheel.tv,1606633-524565, RESELLER 
freewheel.tv,sg 1248060, RESELLER 
freewheel.tv, 534991-r-524565, RESELLER 
freewheel.tv, 534991-r-523319, RESELLER
lkqd.net, 1100053848, RESELLER, 59c49fa9598a0117
connatix.com, 1904974167850082, RESELLER, 2af98acdee0e81ed
vuukle.com, 6e87dead-7381-4c4a-9c2a-03558c1cb17e, DIRECT, c8034d3da4547abf
​​showheroes.com, 7152, DIRECT
loopme.com,15145,RESELLER,6c8d5f95897a5a3b 
xandr.com, 13799, RESELLER
pubmatic.com, 166535, DIRECT, 5d62403b186f2ace
video.unrulymedia.com, 755267463, DIRECT 
video.unrulymedia.com, 321915246, RESELLER
admixer.net, 54aef867-3f67-4273-aa50-bbeca017af0a, DIRECT 
inmobi.com, 61d733c3779d43e590c51c8bc078e10c, RESELLER, 83e75a7ae333ca9d
pubmatic.com, 160846, RESELLER, 5d62403b186f2ace
loopme.com, 11488, RESELLER, 6c8d5f95897a5a3b
e-planning.net, ec771b05828a67fa, RESELLER, c1ba615865ed87b2

#TheGermaneMedia
MANAGERDOMAIN=thegermanemedia.com
INVENTORYPARTNERDOMAIN=thegermanemedia.com
thegermanemedia.com, 193, DIRECT
thegermanemedia.com, 479, DIRECT
google.com, pub-6716225838534735, RESELLER, f08c47fec0942fa0
smartadserver.com, 4938, RESELLER, 060d053dcf45cbf3
pubmatic.com, 164928, RESELLER, 5d62403b186f2ace
freewheel.tv, 1607251, RESELLER
freewheel.tv, 1607259, RESELLER
appnexus.com, 16696, DIRECT, f5ab79cb980f11d1
xandr.com, 16696, DIRECT, f5ab79cb980f11d1
lijit.com, 509119, DIRECT, fafdf38b16bf6b2b
supply.colossusssp.com, 679, DIRECT, 6c5b49d96ec1b458
improvedigital.com, 2446, RESELLER
aps.amazon.com,c581afbf-1c21-414a-bc75-cca4502836b4,DIRECT
lemmatechnologies.com, 1743, DIRECT, 7829010c5bebd1fb
pubmatic.com, 156494, RESELLER, 5d62403b186f2ace
pubmatic.com, 162710, RESELLER, 5d62403b186f2ace

#ELEMENTALTV
inventorypartnerdomain=elementaltv.io
appnexus.com, 11744, DIRECT, f5ab79cb980f11d1
elementaltv.io, 88208865, DIRECT, c67ec7a88426a864
elementaltv.io, 62401427, DIRECT, c67ec7a88426a864
elementaltv.io, 96970841, DIRECT, c67ec7a88426a864
elementaltv.io, 72429098, DIRECT, c67ec7a88426a864
elementaltv.io, 95564760, DIRECT, c67ec7a88426a864
elementaltv.io, 72896576, DIRECT, c67ec7a88426a864
elementaltv.io, 54720706, DIRECT, c67ec7a88426a864
elementaltv.io, 88644635, DIRECT, c67ec7a88426a864
elementaltv.io, 95067602, DIRECT, c67ec7a88426a864
elementaltv.io, 83678508, DIRECT, c67ec7a88426a864
elementaltv.io, 90552245, DIRECT, c67ec7a88426a864
elementaltv.io, 68143334, DIRECT, c67ec7a88426a864
elementaltv.io, 76902717, DIRECT, c67ec7a88426a864
elementaltv.io, 32374835, DIRECT, c67ec7a88426a864
elementaltv.io, 92441949, DIRECT, c67ec7a88426a864
elementaltv.io, 69647629, DIRECT, c67ec7a88426a864
elementaltv.io, 95282147, DIRECT, c67ec7a88426a864
elementaltv.io, 60734128, DIRECT, c67ec7a88426a864
elementaltv.io, 61493294, DIRECT, c67ec7a88426a864
elementaltv.io, 82614493, DIRECT, c67ec7a88426a864
elementaltv.io, 36046903, DIRECT, c67ec7a88426a864
elementaltv.io, 48992805, DIRECT, c67ec7a88426a864
elementaltv.io, 30845062, DIRECT, c67ec7a88426a864
elementaltv.io, 29047783, DIRECT, c67ec7a88426a864

#darkmatter
darkmattertv.com, 55571, DIRECT
inventorypartnerdomain=darkmattertv.com
darkmattertv.com, 374, DIRECT
sabio.us, 100117, RESELLER, 96ed93aaa9795702
Prismriotads.com, 67796, RESELLER, 21e44d1aeccd12ef
TVIQ.io, 326, RESELLER
indicue.com, 1654, RESELLER
inventorypartnerdomain=wurl.com
smartadserver.com, 4054, RESELLER, 060d053dcf45cbf3
sonobi.com, 2400eeabdf, RESELLER, d1a215d9eb5aee9e
sonobi.com, 202ede5988, RESELLER, d1a215d9eb5aee9e
vizio.com, 345067, RESELLER
sonobi.com, 587928c621, RESELLER, d1a215d9eb5aee9e
sabio.us, 100127, RESELLER, 96ed93aaa9795702
lkqd.net, 1100053847, RESELLER, 59c49fa9598a0117
inventorypartnerdomain=space-mob.com
lijit.com, 518134, RESELLER, fafdf38b16bf6b2b
siprocalads.com, O17A8HHKR54DL3L48OQDII6Q6G, RESELLER
siprocalads.com, 4P9ADTEV3D2414L6UNFHNL20OG, RESELLER
adtelligent.com, 446863, RESELLER, 8ce87912eb022a51
filmzie.com, 9894029, RESELLER
safex.tv, 5043, RESELLER
castify.ai, 1270186, RESELLER
inventorypartnerdomain=castify.ai
audienceconnect.io, 551, RESELLER
freewheel.tv, 1596466, RESELLER
boldcollective.co, 498070, RESELLER
inventorypartnerdomain=boldcollective.co

#tviq
inventorypartnerdomain=tviq.io
TVIQ, 2329, DIRECT
TVIQ, 2329, RESELLER
appnexus.com, 1019, RESELLER, f5ab79cb980f11d1
connatix.com, 1652500284288994, RESELLER, 2af98acdee0e81ed
freewheel.tv, 1581801, RESELLER
freewheel.tv, 1600241, RESELLER
lijit.com, 347623, RESELLER, fafdf38b16bf6b2b
media.net, 8CU9U47UY, RESELLER
orka.tv, 83098789, RESELLER, 41c84499561af3f3
pubmatic.com, 159527, RESELLER, 5d62403b186f2ace
pubmatic.com, 161121, reseller, 5d62403b186f2ace
pubmatic.com, 162945, RESELLER, 5d62403b186f2ace
pubmatic.com, 164532, RESELLER, 5d62403b186f2ace
rubiconproject.com, 19564, RESELLER, 0bfd66d529a55807
smartadserver.com, 4417-OB, RESELLER, 060d053dcf45cbf3
supply.colossusssp.com, 238, RESELLER, 6c5b49d96ec1b458
tremorhub.com, 3zcla-3bhdx, RESELLER, 1a4e959a1b50034a
undertone.com, 3648, RESELLER
video.unrulymedia.com, 3128065130, RESELLER
video.unrulymedia.com, 5161057819193970664, RESELLER
Xandr.com, 13416, RESELLER

#altavara
altavara.co, 773907, DIRECT
inventorypartnerdomain=altavara.co
TVIQ, 2335, DIRECT
TVIQ, 2335, RESELLER
inventorypartnerdomain=tviq.io
embi-media.com, 0391, DIRECT
onetag.com, 736328ea479779c, DIRECT
appnexus.com, 10515, DIRECT, f5ab79cb980f11d1
smartadserver.com, 2843, RESELLER, 060d053dcf45cbf3
openx.com, 540861995, direct, 6a698e2ec38604c6
improvedigital.com, 2516, RESELLER
showheroes.com, 7379, DIRECT
152media.info, 152M1039, RESELLER
omgstudios.com, 120420241, DIRECT, f08c47fec0942fa0
google.com, pub-9857612698505806, RESELLER, f08c47fec0942fa0
xandr.com,13291,RESELLER
pubmatic.com, 163283, RESELLER, 5d62403b186f2ace
video.unrulymedia.com, 149448201, RESELLER
appnexus.com, 9382, RESELLER, f5ab79cb980f11d1
appnexus.com, 8283, DIRECT, f5ab79cb980f11d1
openx.com, 539131863, DIRECT, 6a698e2ec38604c6
themediagrid.com, OTJDBI, DIRECT, 35d5010d7789b49d
gumgum.com, 15786, DIRECT, ffdef49475d318a9
rubiconproject.com, 24064, DIRECT, 0bfd66d529a55807
pubmatic.com, 163009, DIRECT, 5d62403b186f2ace
smartadserver.com, 4452, DIRECT, 060d053dcf45cbf3
conversantmedia.com, 100807, RESELLER, 03113cd04947736d

#MetaX
inventorypartnerdomain=metaxsoft.com
metaxsoft.com, 90609223, DIRECT
pubmatic.com,161212, RESELLER, 5d62403b186f2ace
video.unrulymedia.com, 502298505, RESELLER
smartadserver.com, 4454, RESELLER, 060d053dcf45cbf3
xandr.com, 13238, RESELLER, f5ab79cb980f11d1
lijit.com, 515843, RESELLER, fafdf38b16bf6b2b
freewheel.tv, 535399-r-523319, RESELLER
freewheel.tv, 535399-r-169843, RESELLER
thebrave.io,1234773,RESELLER,c25b2154543746ac

#Haxmedia
hax.ortb.net, 655023, RESELLER
freewheel.tv, 1607600, RESELLER
freewheel.tv, 1607602, RESELLER
Contextweb.com, 563542, RESELLER, 89ff185a4c4e857c
bematterfull.com, 89720975345, DIRECT
trustedstack.com, TSH553I92, DIRECT                
rubiconproject.com, 26144, RESELLER, 0bfd66d529a55807
openx.com, 559911747, RESELLER, 6a698e2ec38604c6        
pubmatic.com, 164187, RESELLER, 5d62403b186f2ace

#XAPads
xapads.com, 160884, direct
freewheel.tv, 1581157, RESELLER
pubmatic.com, 166254, RESELLER, 5d62403b186f2ace
appnexus.com, 16916, RESELLER, f5ab79cb980f11d1
conversantmedia.com, 100718, RESELLER, 03113cd04947736d
inmobi.com, c0900989d3194edc94c4f1ae1cd4b9e8, RESELLER, 83e75a7ae333ca9d
video.unrulymedia.com, 906189653, RESELLER
krushmedia.com, AJxF6R667a9M6CaTvK, RESELLER 
conversantmedia.com, 41784, RESELLER, 03113cd04947736d 
sonobi.com, b812bd55d6, RESELLER, d1a215d9eb5aee9e 
media.net, 8CUT87EOU, DIRECT 
supply.colossusssp.com, 610, DIRECT, 6c5b49d96ec1b458

#Bright Mountain
brightmountainmedia.com, 2686459, DIRECT
conversantmedia.com, 100877, RESELLER, 03113cd04947736d
sharethrough.com, 1leEveR6, RESELLER, d53b998a7bd4ecd2
contextweb.com, 563266, RESELLER, 89ff185a4c4e857c
undertone.com, 3832, RESELLER
pubmatic.com, 159527, RESELLER, 5d62403b186f2ace
freewheel.tv, 533472-r-523319, RESELLER
media.net, 8CU9U47UY, RESELLER
lijit.com, 551431, RESELLER, fafdf38b16bf6b2b
inmobi.com, 83a77fcfe06340f6928a82727394b41e, RESELLER, 83e75a7ae333ca9d
thebrave.io, 1234777, RESELLER, c25b2154543746ac
supply.colossusssp.com, 238, RESELLER, 6c5b49d96ec1b458
appnexus.com, 9914, RESELLER

#consumable
consumable.com, 2001477, DIRECT, aefcd3d2f45b5070
tritondigital.com, 106423, DIRECT, 19b4454d0b87b58b
adswizz.com, 561, DIRECT
adswizz.com, 80, RESELLER
adswizz.com, 318, RESELLER
adswizz.com, 666, RESELLER
pubmatic.com, 158408, RESELLER, 5d62403b186f2ace
sonobi.com, 5b003395a5, RESELLER, d1a215d9eb5aee9e
appnexus.com, 7556, RESELLER, f5ab79cb980f11d1
lijit.com, 248396, RESELLER, fafdf38b16bf6b2b
freewheel.tv, sg1244553, RESELLER
freewheel.tv, sg1244553-523319, RESELLER
mobupps.com, c74d97b01eae257e44aa9d5bade97baf33105, RESELLER

#Mosher
mosher.media,326,Direct
improvedigital.com, 2553, RESELLER
adyoulike.com, 6038d2aa7e7f342ff0006deaf2a25c52, DIRECT
Supply.colossusssp.com, 860, DIRECT
xandr.com, 10490, RESELLER
yieldmo.com, 3078438591206989879, RESELLER, #ortb
yieldmo.com, 3081538394287710485, RESELLER, #ortbctv
adswizz.com, moshermedia, RESELLER
adswizz.com, 678, RESELLER

#nobid
inventorypartnerdomain=nobid.io
nobid.io, 22868815669, DIRECT
zetaglobal.net, 693, DIRECT
sharethrough.com, UvcAx8IL, RESELLER, d53b998a7bd4ecd2
video.unrulymedia.com, 347774562, RESELLER
rubiconproject.com, 15268, RESELLER, 0bfd66d529a55807
sharethrough.com, aRE1degH, RESELLER, d53b998a7bd4ecd2
rubiconproject.com, 18694, RESELLER, 0bfd66d529a55807
amxrtb.com, 105199579, RESELLER
appnexus.com, 12290, RESELLER
lijit.com, 260380, RESELLER
lijit.com, 273657, RESELLER, fafdf38b16bf6b2b
rubiconproject.com, 24434, RESELLER, 0bfd66d529a55807
xandr.com, 11429, RESELLER, f5ab79cb980f11d1
onetag.com, 694e68b73971b58, RESELLER
mediafuse.com, 389, DIRECT
pubmatic.com, 159302, RESELLER, 5d62403b186f2ace
appnexus.com, 9538, RESELLER, f5ab79cb980f11d1
Media.net, 8CUV34PJ4, RESELLER
inmobi.com,8f261ace12c3486ba2e0d2011cd97976,RESELLER,83e75a7ae333ca9d
pubmatic.com, 162412, RESELLER, 5d62403b186f2ace
gumgum.com, 13926, RESELLER, ffdef49475d318a9
33across.com, 0010b00002Mq2FYAAZ, DIRECT, bbea06d9c4d2853c #33Across #hb #tag
appnexus.com, 10239, RESELLER, f5ab79cb980f11d1 #33Across #hb #tag #viewable
xandr.com, 12701, RESELLER, f5ab79cb980f11d1

#GLEWED
glewed.tv, 189, DIRECT, 3cc5a0825f527a1e
yahoo.com, 59158, RESELLER, e1a5b5b6e3255540
appnexus.com, 11097, RESELLER, f5ab79cb980f11d1
video.unrulymedia.com, 2014616652, RESELLER
triplelift.com, 12029, RESELLER, 6c33edb13117fd86
freewheel.tv, 1012369, DIRECT
smaato.com, 1100045497, RESELLER, 07bcf65f187117b4
indexexchange.com, 193155, RESELLER, 50b1c356f2c5c8fc
pubmatic.com, 162238, RESELLER, 5d62403b186f2ace

#bidscube
bidscube.com, 3001385, DIRECT, 6ecc87a1e0269657
improvedigital.com, 2480, RESELLER
onetag.com, 758e0f1a8f05074, RESELLER
conversantmedia.com, 100334, DIRECT/RESELLER, 03113cd04947736d
bidinfluence.com, 502096, DIRECT
improvedigital.com, 2418, RESELLER
decenterads.com, 301774, RESELLER
x.adprime.com, AJxF6R19a9M6CaTvK, RESELLER
video.unrulymedia.com, 516878781, RESELLER
pubmatic.com, 159277, RESELLER
openx.com, 543878511, RESELLER, 6a698e2ec38604c6
pubnative.net, 1007449, RESELLER, d641df8625486a7b
sharethrough.com, MAC8ESmG, RESELLER
smaato.com, 1100047589, RESELLER, 07bcf65f187117b4

#bidinfluence
bidscube.com, 3001385, DIRECT, 6ecc87a1e0269657
improvedigital.com, 2480, RESELLER
onetag.com, 758e0f1a8f05074, RESELLER
conversantmedia.com, 100334, DIRECT/RESELLER, 03113cd04947736d
bidinfluence.com, 502096, DIRECT
improvedigital.com, 2418, RESELLER
decenterads.com, 301774, RESELLER
x.adprime.com, AJxF6R19a9M6CaTvK, RESELLER
video.unrulymedia.com, 516878781, RESELLER
pubmatic.com, 159277, RESELLER
openx.com, 543878511, RESELLER, 6a698e2ec38604c6
pubnative.net, 1007449, RESELLER, d641df8625486a7b
sharethrough.com, MAC8ESmG, RESELLER
smaato.com, 1100047589, RESELLER, 07bcf65f187117b4

#Luna
lunamedia.io, 279e21vv468d4r2mu18428c3ac48ca75, DIRECT, 524ecb396915caaf
pubmatic.com, 160493, RESELLER, 5d62403b186f2ace
themediagrid.com, FALINO, DIRECT, 35d5010d7789b49d
contextweb.com, 562329, RESELLER, 89ff185a4c4e857c
smartadserver.com, 4539, RESELLER, 060d053dcf45cbf3
video.unrulymedia.com, 4631344382657206988, DIRECT
freewheel.tv, sg1256499, RESELLER
freewheel.tv, 534466-r-523319, RESELLER
Omnifytv.com, bSqgMQ3ZeJQKpa, DIRECT
myfeature.tv, t8LaxY32FD16rClqT, DIRECT
bematterfull.com, 419532587, DIRECT
zetaglobal.net, 681, RESELLER
conversantmedia.com, 100322, DIRECT, 03113cd04947736d
tropicsgames.com, d5d5bbbb-4e4f-45a5-bcc7-9dd590fcccae, DIRECT

#Siprocal
siprocalads.com, KBCQEE1JP11SP6D770PSGGUC0O, DIRECT
pubmatic.com, 162148, RESELLER, 5d62403b186f2ace
freewheel.tv, sg1246124, RESELLER
freewheel.tv, 533597-r-523319, RESELLER
loopme.com,12890,RESELLER,6c8d5f95897a5a3b
video.unrulymedia.com, 661438163, RESELLER
smartadserver.com, 4443, RESELLER 060d053dcf45cbf3
sharethrough.com, ENJvHawS, DIRECT, d53b998a7bd4ecd2
contextweb.com,562869,RESELLER,89ff185a4c4e857c
yieldmo.com, 3608923449470165093, RESELLER
lijit.com, 522014, RESELLER, fafdf38b16bf6b2b #SOVRN
conversantmedia.com, 100161,RESELLER, 03113cd04947736d
sabio.us, 100066, DIRECT, 96ed93aaa9795702

#EMBI
embi-media.com, 0215, DIRECT
#OCM
appnexus.com, 14416, reseller
adform.com, 3215, reseller
smartadserver.com, 3172, reseller, 060d053dcf45cbf3
Sharethrough.com, voRCbaYL, reseller
appnexus.com, 14808, reseller
adform.com, 2904, reseller
video.unrulymedia.com, 6111915185540403805, reseller
rubiconproject.com, 20086, reseller, 0bfd66d529a55807
adform.com, 2904, reseller
criteo.com, B-060738, direct, 9fac4a4a87c2a44f
themediagrid.com, RVQDTI, direct, 35d5010d7789b49d
contextweb.com, 563490, reseller, 89ff185a4c4e857c #ctv
freewheel.tv, 1512258, reseller  #ctv
freewheel.tv, 1605196, reseller  #ctv
triplelift.com, 13654, reseller  #ctv
#Onetag
onetag.com, 736328ea479779c, DIRECT
advertising.com, 28246, RESELLER
rubiconproject.com, 11006, RESELLER, 0bfd66d529a55807
google.com, pub-3769010358500643, RESELLER, f08c47fec0942fa0
freewheel.tv, 20393, RESELLER
freewheel.tv, 24377, RESELLER
aol.com, 58905, RESELLER, e1a5b5b6e3255540
#Xandr
appnexus.com, 10515, DIRECT, f5ab79cb980f11d1
#IntegralStream
integralstream.com, 511, DIRECT
#Smoot
smoot.ai, 100026, RESELLER
smartadserver.com, 4721, RESELLER
pubmatic.com, 163799, RESELLER, 5d62403b186f2ace

#ORKA
orka.tv, 37734464, DIRECT, 41c84499561af3f3
appnexus.com, 13437, RESELLER, f5ab79cb980f11d1
brightmountainmedia.com, 2686695, RESELLER
connatix.com, 1676721125209786, RESELLER, 2af98acdee0e81ed
conversantmedia.com, 100642, RESELLER, 03113cd04947736d
emxdgt.com, 2547, RESELLER, 1e1d41537f7cad7f
filmzie.com, 9894060, RESELLER
freewheel.tv, 1598940, RESELLER, 74e8e47458f74754
freewheel.tv, 1598941, RESELLER, 74e8e47458f74754
freewheel.tv, 533471-r-523319, RESELLER
freewheel.tv, sg1256505, RESELLER
grouprvn.com, 520202911, RESELLER
inmobi.com, 251e46d6fba54576a2110180c552a59f, RESELLER, 83e75a7ae333ca9d
lgads.tv, 475902, RESELLER
lijit.com, 504676, RESELLER, fafdf38b16bf6b2b
lkqd.net, 1100055764, RESELLER, 59c49fa9598a0117
openx.com, 559612253, RESELLER, 6a698e2ec38604c6
pubmatic.com, 161428, RESELLER, 5d62403b186f2ace
pubmatic.com, 161854, RESELLER, 5d62403b186f2ace
pubmatic.com, 163735, RESELLER, 5d62403b186f2ace
sharethrough.com, lmY9aAKH, RESELLER, d53b998a7bd4ecd2
siprocalads.com, SEQ7S9CH7H0SPD3U4M8JPGECAO, RESELLER
smartadserver.com, 4310, RESELLER
sonobi.com, f70fbb4d0a, RESELLER, d1a215d9eb5aee9e
streamvisionmedia.com, 47524, RESELLER
tmhtechco.com, 1021, RESELLER, 21be5efa891dcce8
tvp.tv, AT70, RESELLER, 1125b6434104a723
video.unrulymedia.com, 2600543444894572145, RESELLER, a670c89d4a324e47
yahoo.com, 60169, RESELLER, e1a5b5b6e3255540
zetaglobal.net, 785, RESELLER

#Aniview
aniview.com, 663c7f06ed40e94b27043335, DIRECT, 78b21b97965ec3f8
pubmatic.com, 160993, RESELLER, 5d62403b186f2ace
freewheel.tv, 1609023, RESELLER
freewheel.tv, 1609024, RESELLER
freewheel.tv, 1588326, RESELLER
freewheel.tv, 1588327, RESELLER
freewheel.tv, 1608979, RESELLER
freewheel.tv, 1608997, RESELLER
freewheel.tv, 1163489, RESELLER
freewheel.tv, 1165025, RESELLER
appnexus.com,16774,RESELLER,f5ab79cb980f11d1
supply.colossusssp.com, 856, RESELLER, 6c5b49d96ec1b458
xandr.com, 10490, RESELLER
yieldmo.com, 3078438591206989879, RESELLER, #ortb
appnexus.com, 12637, RESELLER, f5ab79cb980f11d1
smartadserver.com, 4255, RESELLER
google.com, pub-6346866704322274, RESELLER, f08c47fec0942fa0
contextweb.com, 562929, DIRECT, 89ff185a4c4e857c
sharethrough.com, UXUWG46h, RESELLER, d53b998a7bd4ecd2
media.net, 8CUSP0K53, RESELLER
onetag.com, 57e618150c70d90, RESELLER
video.unrulymedia.com, 3350674472, RESELLER, 6f752381ad5ec0e5
playstream.media, 911, DIRECT
conversantmedia.com, 100195, DIRECT, 03113cd04947736d
themediagrid.com, PRLEZI, RESELLER, 35d5010d7789b49d
lemmatechnologies.com, 429, DIRECT, 7829010c5bebd1fb
pgamssp.com, 6425ca042cf1d9a1a10a7955, RESELLER
onetag.com, 57e618150c70d90, DIRECT
onetag.com, 57e618150c70d90-OB, DIRECT
appnexus.com, 13099, RESELLER
pubmatic.com, 161593, RESELLER, 5d62403b186f2ace
rubiconproject.com, 11006, RESELLER, 0bfd66d529a55807
smartadserver.com, 4111, RESELLER
freewheel.tv, 20393, RESELLER
freewheel.tv, 24377, RESELLER

#take1ads
take1ads.com, 790, DIRECT
pubmatic.com, 160279, RESELLER, 5d62403b186f2ace
pubmatic.com, 157568, RESELLER, 5d62403b186f2ace
smartadserver.com, 4410, RESELLER, 060d053dcf45cbf3
pubmatic.com, 156439, RESELLER, 5d62403b186f2ace
pubmatic.com, 154037, RESELLER, 5d62403b186f2ace
rubiconproject.com, 16114, RESELLER, 0bfd66d529a55807
openx.com, 537149888, RESELLER, 6a698e2ec38604c6
appnexus.com, 3703, RESELLER, f5ab79cb980f11d1
loopme.com, 5679, RESELLER, 6c8d5f95897a5a3b
xad.com, 958, RESELLER, 81cbf0a75a5e0e9a
rhythmone.com, 2564526802, RESELLER, a670c89d4a324e47
smaato.com, 1100044045, RESELLER, 07bcf65f187117b4
pubnative.net, 1006576, RESELLER, d641df8625486a7b
verve.com, 15503, RESELLER, 0c8f5958fc2d6270
adyoulike.com, b4bf4fdd9b0b915f746f6747ff432bde, RESELLER
axonix.com, 57264, RESELLER
admanmedia.com, 43, RESELLER
infolinks.com, 3414360, direct
connatix.com, 1535945088662531, RESELLER, 2af98acdee0e81ed
pubmatic.com, 156592, RESELLER, 5d62403b186f2ace
loopme.com, 11186, RESELLER, 6c8d5f95897a5a3b
freewheel.tv, 1064705, RESELLER
freewheel.tv, sg1256478, RESELLER
freewheel.tv, 535072-r-523319, RESELLER
sharethrough.com, KnLYRz1v, RESELLER, d53b998a7bd4ecd2
smartadserver.com, 3630, RESELLER
contextweb.com, 561340, RESELLER, 89ff185a4c4e857c
concert.io, cbs-91e02cd2b8, RESELLER
richaudience.com, RLpoPHSrZE, RESELLER
pubmatic.com, 81564, RESELLER, 5d62403b186f2ace
pubmatic.com, 156538, RESELLER, 5d62403b186f2ace
rubiconproject.com, 13510, RESELLER
appnexus.com, 8233, RESELLER
pubmatic.com, 166226, RESELLER, 5d62403b186f2ace
insticator.com, f2ff22ea-9f29-4053-974c-2cda89954d3f, RESELLER, b3511ffcafb23a32
gumgum.com, 12991, RESELLER, ffdef49475d318a9
bidgx.com, 62885, RESELLER #DirectDemand
rubiconproject.com, 27034, RESELLER, 0bfd66d529a55807 #PMPDeals
streamvisionmedia.com, 39336, DIRECT
C360.com, 71508, RESELLER
video.unrulymedia.com, 979624895, RESELLER, 29bc7d05d309e1bc
pubmatic.com, 165359, RESELLER, 5d62403b186f2ace
addigi.media, 176543417, DIRECT
freewheel.tv, 1607001, DIRECT
omgstudios.com, 191120242, RESELLER, f08c47fec0942fa0
smartadserver.com, 4871, RESELLER, 060d053dcf45cbf3
embi-media.com, 0391, DIRECT
onetag.com, 736328ea479779c, DIRECT
appnexus.com, 10515, DIRECT, f5ab79cb980f11d1
smartadserver.com, 2843, RESELLER, 060d053dcf45cbf3
openx.com, 540861995, direct, 6a698e2ec38604c6
improvedigital.com, 2516, RESELLER
showheroes.com, 7379, DIRECT
152media.info, 152M1039, RESELLER
tcl.com, pub-410476, direct
freewheel.tv, 512029, RESELLER
pubmatic.com, 164918, DIRECT, 5d62403b186f2ace
pubmatic.com, 159883, DIRECT, 5d62403b186f2ace
openx.com, 558414027, DIRECT, 6a698e2ec38604c6
openx.com, 560680793, DIRECT, 6a698e2ec38604c6

#muxIP
adform.com, 2671, RESELLER
admanmedia.com, 1025, DIRECT
admanmedia.com, 832, DIRECT
advertising.com, 25034, RESELLER
advertising.com, 27495, DIRECT,  e1a5b5b6e3255540
advertising.com, 28575, DIRECT
advertising.com, 28605, RESELLER
altitude-arena.com, G25IAA90GD08T2P554G8744EQO, RESELLER
altitude-arena.com, M9E03AUIOH5B3701LF9C8ULHPG, DIRECT
appnexus.com, 10617, RESELLER
appnexus.com, 11429, DIRECT, f5ab79cb980f11d1
appnexus.com, 11477, DIRECT 
appnexus.com, 12535, DIRECT
appnexus.com, 13307, DIRECT, f5ab79cb980f11d1
appnexus.com, 13360, reseller 
appnexus.com, 13437, DIRECT, f5ab79cb980f11d1
Appnexus.com, 1356, RESELLER, f5ab79cb980f11d1
appnexus.com, 13779, RESELLER
appnexus.com, 1908, RESELLER, f5ab79cb980f11d1 
appnexus.com, 2234, RESELLER
appnexus.com, 4052, RESELLER
appnexus.com, 6849, RESELLER
appnexus.com, 9393, DIRECT
appnexus.com,13307,RESELLER,f5ab79cb980f11d1
appnexus.com,4052,RESELLER
beachfront.com, 13004, DIRECT, e2541279e8e2ca4d
beachfront.com, 14386, DIRECT, e2541279e8e2ca4d
beachfront.com, 14434, DIRECT, e2541279e8e2ca4d
beachfront.com, 14513, RESELLER, e2541279e8e2ca4d
beachfront.com, 14821, DIRECT, e2541279e8e2ca4d
beachfront.com, 14850, DIRECT, e2541279e8e2ca4d
beachfront.com,14838,RESELLER,e2541279e8e2ca4d
consumable.com, 2001372, DIRECT
contextweb.com, 561998, RESELLER, 89ff185a4c4e857c
contextweb.com, 563324, RESELLER, 89ff185a4c4e857c
conversantmedia.com, 100087, DIRECT
conversantmedia.com, 100295, RESELLER, 03113cd04947736d
conversantmedia.com, 100642, RESELLER, 03113cd04947736d
decenterads.com, 933, DIRECT
didna.io, 4169, DIRECT
districtm.io, 101856, DIRECT, 3fd707be9c4527c3
districtm.io, 102029, DIRECT, 3fd707be9c4527c3
durationmedia.net, 22487092286, DIRECT
elementaltv.io, 24879480, RESELLER
elementaltv.io, 78888114, DIRECT
emxdgt.com, 2112, DIRECT, 1e1d41537f7cad7f
EMXDGT.com, 2226, DIRECT, 1e1d41537f7cad7f
emxdgt.com, 2547, RESELLER, 1e1d41537f7cad7f
filmzie.com, 9894060, RESELLER
filmzie.com,1206,RESELLER,
freewheel.tv, 1032001, RESELLER
freewheel.tv, 1033713, RESELLER
freewheel.tv, 1099457, DIRECT
freewheel.tv, 1119233, RESELLER
freewheel.tv, 1134689, RESELLER
freewheel.tv, 1134705, RESELLER
freewheel.tv, 1143217, RESELLER
freewheel.tv, 1143489, RESELLER
freewheel.tv, 1286319, RESELLER
freewheel.tv, 1287135, RESELLER
freewheel.tv, 1306975, DIRECT
freewheel.tv, 1522338, DIRECT
freewheel.tv, 1598940, RESELLER
freewheel.tv, 1598941, RESELLER
freewheel.tv,1158065,RESELLER,
freewheel.tv,1456130,RESELLER,
freewheel.tv,1456146,RESELLER,
freewheel.tv,1456162,RESELLER,
freewheel.tv,1457266,RESELLER,
freewheel.tv,1457282,RESELLER,
freewheel.tv,1457298,RESELLER,
freewheel.tv,848065,RESELLER
google.com, pub-3565385483761681, DIRECT, f08c47fec0942fa0
google.com, pub-5717092533913515, DIRECT, f08c47fec0942fa0
google.com, pub-6694481294649483, DIRECT, f08c47fec0942fa0
google.com, pub-6694481294649483, DIRECT, f08c47fec0942fa0
Improvedigital.com, 1699, RESELLER
improvedigital.com, 1931, DIRECT
indexexchange.com, 182257, RESELLER
indexexchange.com, 185104, DIRECT, 50b1c356f2c5c8fc
indexexchange.com, 186684, DIRECT
indexexchange.com, 191497, RESELLER
indexexchange.com, 197202, DIRECT, 50b1c356f2c5c8fc
indexexchange.com,196129,RESELLER,
indexexchange.com,197202,RESELLER,50b1c356f2c5c8fc
indexexchange.com,198813,RESELLER,50b1c356f2c5c8fc
infolinks.com, 3352691, direct 
inmobi.com,0305346ba9d44234b6631d330ff35784,DIRECT,83e75a7ae333ca9d
inventorypartnerdomain=anandamedia.net
inventorypartnerdomain=answermedia.com
krushmedia.com, AJxF6R477a9M6CaTvK, DIRECT
lgads.tv, 475902, RESELLER
lijit.com, 248396-eb, DIRECT, fafdf38b16bf6b2b
lijit.com, 504676, RESELLER, fafdf38b16bf6b2b
lkqd.net, 666, DIRECT, 59c49fa9598a0117
lkqd.net,966,RESELLER,59c49fa9598a0117
mobilefuse.com,240,RESELLER,71e88b065d69c021
nobid.io, 22142182673, DIRECT
nobid.io, 22317370171, DIRECT
nobid.io, 22487092286, DIRECT
onetag.com, 694e68b73971b58, DIRECT
onetag.com, 6c68086c0c61793, DIRECT
openx.com, 540031703, RESELLER, 6a698e2ec38604c6
openx.com, 540845629, DIRECT, 6a698e2ec38604c6
openx.com, 543878511, RESELLER, 6a698e2ec38604c6
openx.com, 544095453, DIRECT, 6a698e2ec38604c6
openx.com, 559612253, RESELLER, 6a698e2ec38604c6
originmedia.tv, 10091922, DIRECT, 117241431
orka.tv, 61222802, DIRECT
orka.tv, 61222802, DIRECT, 41c84499561af3f3
pub-9130183266015225, RESELLER, f08c47fec0942fa0
pubmatic.com, 156695, DIRECT, 5d62403b186f2ace
pubmatic.com, 157898, DIRECT, 5d62403b186f2ace
pubmatic.com, 158481, RESELLER, 5d62403b186f2ace
pubmatic.com, 159117, DIRECT, 5d62403b186f2ace
pubmatic.com, 159277, RESELLER, 5d62403b186f2ace
pubmatic.com, 159302, DIRECT, 5d62403b186f2ace
pubmatic.com, 159396, RESELLER
pubmatic.com, 159744, DIRECT, 5d62403b186f2ace
pubmatic.com, 159745, DIRECT, 5d62403b186f2ace
pubmatic.com, 160058, DIRECT, 5d62403b186f2ace
pubmatic.com, 161121, reseller, 5d62403b186f2ace 
pubmatic.com, 161428, DIRECT, 5d62403b186f2ace
pubmatic.com, 161508, DIRECT, 5d62403b186f2ace
pubmatic.com, 161854, DIRECT, 5d62403b186f2ace
pubmatic.com, 161854, RESELLER, 5d62403b186f2ace
pubmatic.com, 163161, RESELLER, 5d62403b186f2ace
pubmatic.com, 163735, RESELLER, 5d62403b186f2ace
pubmatic.com, 27495, RESELLER, 5d62403b186f2ace
Pubmatic.com,158651,RESELLER,5d62403b186f2ace
pubmatic.com,160455,RESELLER,5d62403b186f2ace
pubmatic.com,161508,RESELLER,5d62403b186f2ace
pubmatic.com,161757,RESELLER,5d62403b186f2ace
rhythmone.com, 1707194545, DIRECT, a670c89d4a324e47
rhythmone.com, 1837834705,DIRECT,a670c89d4a324e47
rhythmone.com, 2221906906, reseller, a670c89d4a324e47 
rhythmone.com, 2550753992, DIRECT, a670c89d4a324e47
rhythmone.com, 2600543444894572145, DIRECT, a670c89d4a324e47
rhythmone.com, 2736329702851206590, DIRECT, a670c89d4a324e47
rhythmone.com, 3948367200, RESELLER, a670c89d4a324e47
rhythmone.com, 55062386,DIRECT,a670c89d4a324e47
rubiconproject.com, 13702, DIRECT, 0bfd66d529a55807
rubiconproject.com, 15268, RESELLER
rubiconproject.com, 20100, DIRECT, 0bfd66d529a55807
rubiconproject.com, 20102, DIRECT, 0bfd66d529a55807
rubiconproject.com, 23644, RESELLER, 0bfd66d529a55807
rubiconproject.com,20744,RESELLER,0bfd66d529a55807
showheroes.com, 381, DIRECT
siprocalads.com, SEQ7S9CH7H0SPD3U4M8JPGECAO, RESELLER
smartadserver.com, 3713, RESELLER
smartadserver.com, 4010, DIRECT
smartadserver.com, 4071, DIRECT
smartadserver.com, 4310, DIRECT
smartadserver.com, 4942, RESELLER, 060d053dcf45cbf3
smartadserver.com,4071,RESELLER,
smartadserver.com,4228,RESELLER,
smartadserver.com,4311,RESELLER,
sonobi.com, 6e5cfb5420, DIRECT
sonobi.com, 7b37f8ccbc, RESELLER, d1a215d9eb5aee9e
spotx.tv, 141052 , RESELLER, 7842df1d2fe2db34  
spotx.tv, 239904, RESELLER, 7842df1d2fe2db34
spotx.tv, 240697, RESELLER, 7842df1d2fe2db34
spotx.tv, 260234, RESELLER, 7842df1d2fe2db34
spotx.tv, 265438, DIRECT, 7842df1d2fe2db34
spotx.tv, 270977, DIRECT, 7842df1d2fe2db34
spotx.tv, 281072, DIRECT, 7842df1d2fe2db34
spotx.tv, 284496, DIRECT, 7842df1d2fe2db34
spotx.tv, 311689, DIRECT, 7842df1d2fe2db34
spotx.tv, 85519, DIRECT, 7842df1d2fe2db34
spotx.tv,265438,DIRECT,7842df1d2fe2db34
spotx.tv,284496,DIRECT,7842df1d2fe2db34
spotx.tv,311689,DIRECT,7842df1d2fe2db34
spotxchange.com, 240697, RESELLER, 7842df1d2fe2db34
spotxchange.com, 260234, RESELLER, 7842df1d2fe2db34
spotxchange.com, 265438, RESELLER, 7842df1d2fe2db34
spotxchange.com, 270977, DIRECT, 7842df1d2fe2db34
spotxchange.com, 281072, DIRECT, 7842df1d2fe2db34
spotxchange.com, 284496,DIRECT, 7842df1d2fe2db34
spotxchange.com, 285260, RESELLER, 7842df1d2fe2db34
spotxchange.com, 311689, DIRECT, 7842df1d2fe2db34
spotxchange.com, 85519, DIRECT, 7842df1d2fe2db34
spotxchange.com,265438,DIRECT,7842df1d2fe2db34
spotxchange.com,284496,DIRECT,7842df1d2fe2db34
spotxchange.com,311689,DIRECT,7842df1d2fe2db34
springserve.com, 1206, DIRECT, a24eb641fc82e93d 
springserve.com, 1247, DIRECT, a24eb641fc82e93d
springserve.com, 810, DIRECT, a24eb641fc82e93d
streamvisionmedia.com, 47524, RESELLER
supply.colossusssp.com, 196, DIRECT, 6c5b49d96ec1b458
synacor.com, 82101, DIRECT, e108f11b2cdf7d5b
telaria.com, 3zcla-3bhdx, RESELLER,1a4e959a1b50034a
telaria.com, auap-zihku, DIRECT, 1a4e959a1b50034a
telaria.com, k1v05-4a3li, RESELLER, 1a4e959a1b50034a
telaria.com, oyz9, RESELLER, 1a4e959a1b50034a
telaria.com, oyz9g-ocspl, RESELLER, 1a4e959a1b50034a
telaria.com, sml5f-iakbb, DIRECT, 1a4e959a1b50034a
telaria.com, vtrdn-wjdav, DIRECT, 1a4e959a1b50034a
telaria.com,2auap-45web,RESELLER,1a4e959a1b50034a
telaria.com,2auap-zihku,DIRECT,1a4e959a1b50034a
telaria.com,sml5f-40qc0,DIRECT,1a4e959a1b50034a
telaria.com,sml5f-7jhgv,DIRECT,1a4e959a1b50034a
telaria.com,sml5f-9p3hg,DIRECT,1a4e959a1b50034a
telaria.com,sml5f-iakbb,DIRECT,1a4e959a1b50034a
themediagrid.com, NGTYF8, DIRECT, 35d5010d7789b49d
tmhtechco.com, 1021, DIRECT, 21be5efa891dcce8
tremorhub.com, 3zcla-3bhdx, RESELLER,1a4e959a1b50034a
tremorhub.com, auap-zihku, DIRECT, 1a4e959a1b50034a
tremorhub.com, k1v05-4a3li, RESELLER, 1a4e959a1b50034a
tremorhub.com, oyz9g-ocspl, RESELLER, 1a4e959a1b50034a
tremorhub.com, sml5f-iakbb, DIRECT, 1a4e959a1b50034a
tremorhub.com, vtrdn-ysjam, DIRECT, 1a4e959a1b50034a
tremorhub.com,2auap-45web,RESELLER,1a4e959a1b50034a
tremorhub.com,2auap-zihku,DIRECT,1a4e959a1b50034a
tremorhub.com,sml5f-40qc0,DIRECT,1a4e959a1b50034a
tremorhub.com,sml5f-7jhgv,DIRECT,1a4e959a1b50034a
tremorhub.com,sml5f-9p3hg,DIRECT,1a4e959a1b50034a
tremorhub.com,sml5f-iakbb,DIRECT,1a4e959a1b50034a
triplelift.com, 11342, DIRECT, 6c33edb13117fd86
triplelift.com, 8867, DIRECT, 6c33edb13117fd86
triplelift.com, 9789, DIRECT, 6c33edb13117fd86
triplelift.com,11341,RESELLER,6c33edb13117fd86
triplelift.com,11342,RESELLER,6c33edb13117fd86
TVP Ads.txt: tvp.tv, AB38, DIRECT, 1125b6434104a723
tvp.tv, AB38, DIRECT, 1125b6434104a723
tvp.tv, AT70, RESELLER, 1125b6434104a723
tvp.tv,AE98,RESELLER,1125b6434104a723
uis.mobfox.com, SM_828, DIRECT, 5529a3d1f59865be
undertone.com, 3452, DIRECT
undertone.com, 3817, DIRECT
undertone.com,4143,RESELLER,
verve.com, 15624, RESELLER, 0c8f5958fc2d6270
video.unrulymedia.com, 1076928510, DIRECT
video.unrulymedia.com, 1707194545, DIRECT
video.unrulymedia.com, 1837834705, DIRECT
video.unrulymedia.com, 2221906906, reseller
video.unrulymedia.com, 2550753992, DIRECT
video.unrulymedia.com, 2600543444894572145, DIRECT
video.unrulymedia.com, 2600543444894572145, RESELLER, a670c89d4a324e47
video.unrulymedia.com, 2736329702851206590, DIRECT
video.unrulymedia.com, 3948367200, RESELLER
video.unrulymedia.com, 55062386, DIRECT
videobridge.tv, 16782, DIRECT, 1adef68921d318a3
xandr.com, 11744, DIRECT, f5ab79cb980f11d1
xandr.com, 13437, DIRECT, f5ab79cb980f11d1
xandr.com, 8804, RESELLER, f5ab79cb980f11d1
yahoo.com, 55104, DIRECT, e1a5b5b6e3255540
yahoo.com, 55771, RESELLER, e1a5b5b6e3255540
yahoo.com, 57289, RESELLER, e1a5b5b6e3255540
yahoo.com, 57695, DIRECT, e1a5b5b6e3255540
yahoo.com, 59120, RESELLER, e1a5b5b6e3255540
yahoo.com, 59642, DIRECT, e1a5b5b6e3255540
yahoo.com, 60169, RESELLER, e1a5b5b6e3255540
yahoo.com, 57349, reseller
yahoo.com, 55771,RESELLER,e1a5b5b6e3255540
yahoo.com, 59242,RESELLER,e1a5b5b6e3255540
yahoo.com, 57349, reseller
zetaglobal.net, 785, RESELLER
freewheel.tv, sg1245079, RESELLER                 
freewheel.tv, 533587-r-524565, RESELLER    
freewheel.tv, 533587-r-523319, RESELLER  
improvedigital.com, 2506, DIRECT 
improvedigital.com, 2506, RESELLER`;

  useEffect(() => {
    // Set the content type to text/plain
    document.querySelector('meta[name="content-type"]')?.setAttribute('content', 'text/plain');
  }, []);

  // Return the content as plain text
  return (
    <pre style={{ 
      fontFamily: 'monospace', 
      whiteSpace: 'pre-wrap', 
      margin: 0,
      padding: 0,
      backgroundColor: 'transparent',
      border: 'none',
      fontSize: '12px',
      lineHeight: '1.2'
    }}>
      {adsTxtContent}
    </pre>
  );
};

export default AdsTxt;

